import { render, staticRenderFns } from "./createSaidaProduto.vue?vue&type=template&id=50403591&scoped=true"
import script from "./createSaidaProduto.vue?vue&type=script&lang=js"
export * from "./createSaidaProduto.vue?vue&type=script&lang=js"
import style0 from "./createSaidaProduto.vue?vue&type=style&index=0&id=50403591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50403591",
  null
  
)

export default component.exports